import React, { useState } from "react";
import toast from "react-hot-toast";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import icons from "../../../assets/images/constantIcons";

const PasswordPopup = ({ isOpen, onClose, onPasswordSuccess, customerId,customerName,passwordAction }) => {
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleSubmit = async () => {
        if (!password) return toast.error("Enter password");
        setLoading(true);
        try {
            const response = await apiService.get(`/customer_users/${customerId}?password=${password}`);
            if (response.status === 200) {
                onPasswordSuccess(password);
            }
        } catch (errors) {
            handleError(errors);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
                <h3 className="text-xl font-semibold mb-7 text-G500 text-start">Enter Password to {passwordAction} <br/><span className="text-G200">({customerName})</span> </h3>
                <div className="absolute top-5 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px] flex justify-center items-center"
                    onClick={onClose}
                >
                    <icons.IoClose className="text-green700 text-xl" />
                </div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                >
                    <div className="relative text-G300 ">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            name="password"
                            autoComplete="new-password"
                            className="inputtext relative"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="absolute right-3 top-3 text-green"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                            {showConfirmPassword ? <icons.FaEye /> : <icons.FaEyeSlash />}
                        </button>
                    </div>
                    <div className="flex justify-end space-x-4 pt-8">
                        <button
                            type="button"
                            className="w-[75px] sm:w-[93px] py-2 text-center text-sm bg-white text-green rounded-lg border border-green"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className="w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg bg-green text-white"
                        >
                            {loading ? "Verifying..." : "Submit"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PasswordPopup;
